import { Component, computed, inject } from '@angular/core';
import { TableLazyLoadEvent, TableModule, TableRowSelectEvent } from 'primeng/table';
import { RaadgivereService } from '../raadgivere.service';
import { DatePipe } from '@angular/common';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { KeepScrollPositionDirective } from '@shared/directives/keep-scroll-position.directive';

@Component({
  selector: 'app-raadgiver-result',
  imports: [TableModule, DatePipe, TableRowDirective, KeepScrollPositionDirective],
  templateUrl: './raadgiver-result.component.html',
  styleUrl: './raadgiver-result.component.css',
})
export class RaadgiverResultComponent {
  raadgiverService = inject(RaadgivereService);
  data = this.raadgiverService.datasource.data;
  tableData = computed(() => this.data()?.data || []);

  onRowSelect(e: TableRowSelectEvent) {
    this.raadgiverService.selectRaadgiverResultRow(e.data);
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    this.raadgiverService.datasource.loadData(
      event.sortField,
      event.sortOrder === -1,
      event.first
    );
  }
}
